export default __webpack_public_path__ + "static/media/en.7bb03f7e.svg";